var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicket = function SvgTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_8175_3500)",
    fillRule: "evenodd",
    d: "M22.047 3.952c.396.33.617.816.617 1.362v9.873c0 .282-.059.572-.174.851-.115.28-.284.546-.496.781a2.9 2.9 0 0 1-.743.59c-.277.155-.575.26-.875.31l-2.74.467a2.13 2.13 0 0 1-1.248-.142l-1.247-.573-.61-.524 1.247.574c.37.168.803.218 1.247.141l2.74-.466c.301-.05.598-.155.876-.31s.53-.355.743-.59c.212-.236.38-.501.496-.781s.174-.57.174-.851V4.79c0-.545-.221-1.032-.617-1.361z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_8175_3500)",
    fillRule: "evenodd",
    d: "m15.142 17.47-.932.848a2.83 2.83 0 0 1-1.37.684L4.39 20.439c-.3.05-.596.046-.873-.015a1.9 1.9 0 0 1-.74-.338l-.61-.524c.212.163.463.278.74.339.277.06.574.065.873.014l8.448-1.437c.497-.09.978-.33 1.37-.684l.932-.847z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M2.716 20.035a1.7 1.7 0 0 1-.432-.56 1.8 1.8 0 0 1-.174-.792V8.81c0-.568.24-1.154.668-1.63a2.85 2.85 0 0 1 1.614-.901l8.461-1.44c.498-.08.98-.004 1.37.218l.94.529-.61-.524-.94-.529c-.39-.222-.872-.298-1.37-.217l-8.461 1.44a2.85 2.85 0 0 0-1.614.901c-.428.475-.668 1.061-.668 1.63v9.873c0 .281.059.55.174.79.103.217.25.407.432.562z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m15.16 5.586 1.234-.995c.37-.294.803-.491 1.247-.566l2.74-.467c.606-.102 1.186.025 1.614.354l-.61-.524c-.428-.329-1.008-.456-1.613-.353l-2.74.466a2.75 2.75 0 0 0-1.248.566l-1.233.995z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_8175_3500)",
    fillRule: "evenodd",
    d: "M15.639 11.016a.55.55 0 0 0-.248-.123.7.7 0 0 0-.396.03.9.9 0 0 0-.351.236.8.8 0 0 0-.188.362.58.58 0 0 0 .04.365q.045.095.124.164l-.61-.524a.5.5 0 0 1-.125-.163.58.58 0 0 1-.039-.366.8.8 0 0 1 .188-.361.9.9 0 0 1 .35-.236.7.7 0 0 1 .396-.03q.145.031.248.122z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M14.62 12.05q.056.049.128.083a.65.65 0 0 0 .38.043.86.86 0 0 0 .485-.27.74.74 0 0 0 .2-.49.53.53 0 0 0-.174-.4l-.61-.523a.51.51 0 0 1 .175.4c0 .17-.073.346-.201.489a.86.86 0 0 1-.485.27.65.65 0 0 1-.38-.043.5.5 0 0 1-.128-.082zM15.636 14.038l-.023-.018-.61-.524.022.018z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_8175_3500)",
    fillRule: "evenodd",
    d: "M15.613 14.02a.62.62 0 0 0-.485-.106.84.84 0 0 0-.38.173.83.83 0 0 0-.253.332.64.64 0 0 0-.039.378.5.5 0 0 0 .165.28l-.61-.524a.5.5 0 0 1-.165-.28.64.64 0 0 1 .04-.378.84.84 0 0 1 .252-.331.84.84 0 0 1 .38-.174.62.62 0 0 1 .485.106z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m14.622 15.077.022.018-.61-.524-.022-.018z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M14.643 15.095a.6.6 0 0 0 .351.116.8.8 0 0 0 .396-.104.9.9 0 0 0 .307-.289.7.7 0 0 0 .116-.377.52.52 0 0 0-.178-.403l-.61-.523a.52.52 0 0 1 .178.402.7.7 0 0 1-.116.377.87.87 0 0 1-.307.29.8.8 0 0 1-.396.104.6.6 0 0 1-.35-.117z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_8175_3500)",
    fillRule: "evenodd",
    d: "M15.639 7.99a.55.55 0 0 0-.248-.122.7.7 0 0 0-.396.03.9.9 0 0 0-.351.237.8.8 0 0 0-.188.361.58.58 0 0 0 .04.365q.045.095.124.164l-.61-.524a.5.5 0 0 1-.125-.163.58.58 0 0 1-.039-.366.8.8 0 0 1 .188-.361.9.9 0 0 1 .35-.236.7.7 0 0 1 .396-.03q.145.031.248.122z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M14.62 9.025q.056.049.128.082a.65.65 0 0 0 .38.043.86.86 0 0 0 .485-.27.74.74 0 0 0 .2-.49.53.53 0 0 0-.174-.4l-.61-.523a.51.51 0 0 1 .175.4c0 .17-.073.346-.201.489a.86.86 0 0 1-.485.27.65.65 0 0 1-.38-.043.5.5 0 0 1-.128-.082z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_8175_3500)",
    d: "M6.917 10.086a4 4 0 0 1 .844-.026l.129.034-.61-.523-.129-.034a4 4 0 0 0-.844.025 5.4 5.4 0 0 0-.864.185 5.4 5.4 0 0 0-.838.316q-.405.187-.736.423a3.3 3.3 0 0 0-.574.514q-.243.27-.351.569a1.1 1.1 0 0 0-.074.391.45.45 0 0 0 .087.265.4.4 0 0 0 .059.06l.61.524a.4.4 0 0 1-.058-.06.45.45 0 0 1-.088-.265q-.007-.16.074-.392.109-.297.351-.569a3.3 3.3 0 0 1 .574-.513q.33-.237.736-.424.405-.192.838-.316.432-.13.864-.184"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M3.626 12.81q.067.06.165.093.141.045.324.044.094-.003.216-.018l-.61-.523q-.122.014-.216.018-.183 0-.325-.044a.5.5 0 0 1-.164-.094z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m4.332 12.93.27-.047-.61-.523-.27.046zM4.602 12.883q.027-.315.102-.582.08-.275.263-.504.19-.231.527-.425.337-.2.898-.37l-.61-.524a4.2 4.2 0 0 0-.898.37q-.338.195-.527.425-.183.23-.264.504-.074.268-.1.583z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_8175_3500)",
    fillRule: "evenodd",
    d: "M6.392 11.002a31 31 0 0 0-.196 1.051q-.102.595-.176 1.216-.067.615-.087 1.183-.015.567.06.964l-.61-.523a4.7 4.7 0 0 1-.06-.965q.02-.569.087-1.182.074-.622.176-1.216.101-.595.196-1.052z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M5.993 15.416q.135.114.29.15.161.033.338.029.175 0 .358-.03a6 6 0 0 1 .385-.04L6.754 15q-.196.015-.385.04-.183.031-.358.03a1.4 1.4 0 0 1-.338-.03.7.7 0 0 1-.29-.148zM7.364 15.525q.318-.8.682-1.607T8.77 12.2l-.61-.523q-.359.91-.723 1.719A38 38 0 0 0 6.754 15z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_8175_3500)",
    fillRule: "evenodd",
    d: "M8.769 12.2a14 14 0 0 0-.04.776q0 .342.013.656.013.315.034.64.027.32.054.718.009.15.091.224l-.61-.523q-.082-.075-.092-.225a43 43 0 0 0-.054-.717q-.02-.325-.033-.64t-.014-.656q.007-.343.04-.777z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M8.922 15.214a.3.3 0 0 0 .083.05.9.9 0 0 0 .399.044q.237-.015.486-.077.25-.06.432-.098l-.61-.524q-.181.038-.432.099-.25.06-.486.076a.9.9 0 0 1-.399-.044.3.3 0 0 1-.083-.05z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M10.322 15.133q.15-.44.338-.94.189-.503.412-1.032.223-.528.466-1.06.249-.54.513-1.044.27-.51.547-.975a10 10 0 0 1 .56-.84l-.61-.524q-.284.378-.56.84a21 21 0 0 0-1.06 2.02q-.244.53-.467 1.06a28 28 0 0 0-.411 1.032 26 26 0 0 0-.338.94z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear_8175_3500)",
    fillRule: "evenodd",
    d: "M13.158 9.242a.8.8 0 0 0-.371-.11 1.5 1.5 0 0 0-.419.015 2 2 0 0 0-.439.112 5 5 0 0 0-.418.177l-.61-.524q.202-.096.418-.177a2 2 0 0 1 .439-.112q.216-.037.419-.015.21.014.371.11z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M9.727 13.67q.02-.259.061-.6.047-.35.101-.726a47 47 0 0 1 .385-2.102q.06-.27.102-.415l-.61-.523a8 8 0 0 0-.102.414l-.121.605q-.068.34-.135.73-.067.385-.129.768-.054.375-.101.725-.04.342-.06.6z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#6580E1",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "m10.375 9.827-.003-.003-.61-.524.003.003z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear_8175_3500)",
    fillRule: "evenodd",
    d: "M10.373 9.824a.46.46 0 0 0-.22-.101 1.4 1.4 0 0 0-.29-.026q-.148 0-.31.028a8 8 0 0 0-.297.045l-.61-.524q.141-.023.297-.044.162-.028.31-.028.155-.002.29.025a.46.46 0 0 1 .22.102z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear_8175_3500)",
    fillRule: "evenodd",
    d: "M9.255 9.77q-.108.135-.264.398-.155.256-.344.611-.189.35-.405.77l-.44.87q-.221.454-.458.923l-.466.905-.61-.523.466-.906q.236-.468.459-.922l.439-.87q.216-.421.405-.77.188-.355.344-.612a4 4 0 0 1 .264-.398z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_linear_8175_3500)",
    fillRule: "evenodd",
    d: "M11.51 9.436a7 7 0 0 0-.547 1.03q-.243.563-.452 1.14-.203.567-.392 1.11a9 9 0 0 1-.392.954l-.61-.524q.203-.42.392-.955.19-.54.392-1.11.21-.575.452-1.138t.547-1.03z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_linear_8175_3500)",
    fillRule: "evenodd",
    d: "m17.033 3.501 2.74-.466c.605-.103 1.186.024 1.614.353.427.33.668.834.668 1.402v9.873c0 .282-.06.572-.175.852s-.283.545-.496.78a2.9 2.9 0 0 1-.742.59c-.278.155-.575.26-.876.311l-2.74.466a2.13 2.13 0 0 1-1.247-.142l-1.247-.573-.932.848a2.83 2.83 0 0 1-1.37.683l-8.448 1.437c-.3.051-.597.046-.874-.014a1.9 1.9 0 0 1-.74-.339 1.7 1.7 0 0 1-.494-.611 1.8 1.8 0 0 1-.174-.79V8.286c0-.569.24-1.155.668-1.63a2.85 2.85 0 0 1 1.614-.902l8.461-1.44c.498-.08.98-.004 1.37.218l.94.53 1.233-.996c.369-.294.803-.491 1.247-.566m-2.896 8.108a.65.65 0 0 0 .381.043.86.86 0 0 0 .484-.27.74.74 0 0 0 .201-.49.53.53 0 0 0-.115-.338.54.54 0 0 0-.308-.184.7.7 0 0 0-.396.03.9.9 0 0 0-.35.236.8.8 0 0 0-.188.362.58.58 0 0 0 .039.365c.052.109.14.194.252.246m.95 2.686a.7.7 0 0 0 .116-.378.52.52 0 0 0-.2-.42.62.62 0 0 0-.485-.107.84.84 0 0 0-.38.173.84.84 0 0 0-.253.332.64.64 0 0 0-.039.379.5.5 0 0 0 .188.298.6.6 0 0 0 .35.116.8.8 0 0 0 .396-.104.9.9 0 0 0 .308-.29m-.95-5.711a.65.65 0 0 0 .381.043.86.86 0 0 0 .484-.27.74.74 0 0 0 .201-.49.53.53 0 0 0-.115-.338.54.54 0 0 0-.308-.184.7.7 0 0 0-.396.03.9.9 0 0 0-.35.236.8.8 0 0 0-.188.362.58.58 0 0 0 .039.365c.052.109.14.194.252.246m-6.856.987-.129-.034a4 4 0 0 0-.844.026 5.4 5.4 0 0 0-.864.184 5.4 5.4 0 0 0-.838.316q-.405.187-.736.423-.33.238-.574.514-.243.27-.35.57a1.1 1.1 0 0 0-.075.39.45.45 0 0 0 .088.265q.081.104.222.155.142.044.325.044.095-.005.216-.018l.27-.046q.027-.315.101-.583.081-.274.264-.504.189-.231.526-.425.338-.2.898-.37-.094.457-.195 1.052t-.176 1.216q-.067.614-.088 1.182-.013.567.061.965.135.113.29.149.162.034.338.03.175 0 .358-.03.189-.027.385-.041.318-.8.682-1.606.364-.808.723-1.72-.034.435-.04.778 0 .34.013.656.014.314.033.64.027.317.054.717.014.215.176.274a.9.9 0 0 0 .398.044q.237-.015.487-.076.249-.061.432-.098.148-.442.338-.94.189-.504.411-1.032.223-.53.466-1.06.25-.54.514-1.044.27-.512.547-.975.276-.464.56-.84a.8.8 0 0 0-.371-.111 1.5 1.5 0 0 0-.419.015 2 2 0 0 0-.439.112 5 5 0 0 0-.419.177 7 7 0 0 0-.547 1.03q-.243.563-.452 1.14-.203.567-.392 1.11a9 9 0 0 1-.391.954q.02-.258.06-.6l.102-.726a47 47 0 0 1 .385-2.102q.06-.27.1-.415a.46.46 0 0 0-.222-.104 1.4 1.4 0 0 0-.29-.026q-.15 0-.311.028a8 8 0 0 0-.297.045 4 4 0 0 0-.264.399q-.155.255-.344.61-.189.35-.405.771l-.44.87q-.221.454-.458.923l-.466.905.162-.748.175-.831q.095-.426.183-.838a31 31 0 0 1 .344-1.363q.081-.255.149-.373",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8175_3500",
    x1: 18.494,
    x2: 19.795,
    y1: 3.429,
    y2: 17.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8175_3500",
    x1: 8.489,
    x2: 8.536,
    y1: 16.947,
    y2: 20.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8175_3500",
    x1: 14.713,
    x2: 14.79,
    y1: 10.354,
    y2: 12.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8175_3500",
    x1: 14.7,
    x2: 14.779,
    y1: 13.38,
    y2: 15.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8175_3500",
    x1: 14.713,
    x2: 14.79,
    y1: 7.33,
    y2: 9.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8175_3500",
    x1: 5.315,
    x2: 5.42,
    y1: 9.526,
    y2: 12.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8175_3500",
    x1: 5.842,
    x2: 6.898,
    y1: 10.478,
    y2: 15.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8175_3500",
    x1: 8.509,
    x2: 9.235,
    y1: 11.676,
    y2: 15.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8175_3500",
    x1: 12.001,
    x2: 12.015,
    y1: 8.6,
    y2: 9.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8175_3500",
    x1: 9.487,
    x2: 9.499,
    y1: 9.174,
    y2: 9.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8175_3500",
    x1: 7.723,
    x2: 8.129,
    y1: 9.246,
    y2: 14.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8175_3500",
    x1: 10.283,
    x2: 10.74,
    y1: 8.912,
    y2: 13.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593B0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8175_3500",
    x1: 2.391,
    x2: 21.043,
    y1: 6.259,
    y2: 20.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FFD659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#FFE79E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#FFC559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B6103"
  })))));
};
export default SvgTicket;